export const city_centers = {
  1: [58.238498797280926, 37.94538747522459],
  2: [68.787, 38.56],
  3: [71.6725, 40.9952778],
  4: [72.7981, 40.5139],
  5: [69.1667, 54.8833],
};
